import {
  CalendarRange, Navigation, FileText, Receipt, CreditCard, BookOpen, ShieldCheck,
  Megaphone, Mic, Sparkles, PhoneCall, Headset, Brain, Smartphone, MapPin, Clock,
  Wallet, MessageSquare, Inbox, Users, Kanban, BarChart3, Workflow, Wrench, Droplets,
  Waves, Trees, Home, Building2, HardHat, PhoneIncoming, Bot, Flame, Zap, Star,
} from "lucide-react";

// Shared icon registry keyed by string name so data files stay plain JS
// (no JSX/import churn needed when adding a new feature/industry/solution entry).
export const MARKETING_ICONS = {
  CalendarRange, Navigation, FileText, Receipt, CreditCard, BookOpen, ShieldCheck,
  Megaphone, Mic, Sparkles, PhoneCall, Headset, Brain, Smartphone, MapPin, Clock,
  Wallet, MessageSquare, Inbox, Users, Kanban, BarChart3, Workflow, Wrench, Droplets,
  Waves, Trees, Home, Building2, HardHat, PhoneIncoming, Bot, Flame, Zap, Star,
};

export function getMarketingIcon(name) {
  return MARKETING_ICONS[name] || Sparkles;
}
